import axios from "axios";
import { useState, useEffect } from "react";

export const useBooking = () => {
  const [extraBedPrice, setExtraBedPrice] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("paypal");

  const fetchData = async () => {
    try {
      const [extraBedPriceResponse, paymentMethodResponse] = await Promise.all([
        axios.get("/api/extrabedprice/get"),
        axios.get("/api/paymentmethod/getPaymentMethod"),
      ]);
      setExtraBedPrice(extraBedPriceResponse.data.price);
      setPaymentMethod(paymentMethodResponse.data.method);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Scroll to top when booking screen mounts (navigate to /booking)
  useEffect(() => {
    if (typeof window !== "undefined" && window.scrollTo) {
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (e) {
        // fallback for older browsers
        window.scrollTo(0, 0);
      }
    }
  }, []);

  return {
    fetchData,
    extraBedPrice,
    paymentMethod,
  };
};
